import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconTruck from '@/icons/Truck.svg';
import { SHIPMENT_CARRIERS_WITH_MORE_OPTIONS, useGetCarrierName } from '@/models/shipment';

import { useFilters } from '../FiltersState';

export const FiltersCarrier = () => {
  const { t } = useLingui();
  const getCarrierName = useGetCarrierName();

  const {
    carriers: { carriers, setCarriers },
  } = useFilters();

  const toggleCarrier = (carrier: (typeof carriers)[number]) => {
    if (carriers.includes(carrier)) {
      setCarriers(carriers.filter((c) => c !== carrier));
    } else {
      setCarriers([...carriers, carrier]);
    }
  };

  return (
    <FiltersSubMenu
      id="carrier"
      icon={<IconTruck />}
      label={t({ id: 'shipments.filters.carrier.label', message: 'Carrier' })}
      count={carriers.length}
    >
      <FiltersList
        ariaLabel={t({ id: 'shipments.filters.carrier.label', message: 'Carrier' })}
        values={carriers}
        onChange={toggleCarrier}
      >
        {SHIPMENT_CARRIERS_WITH_MORE_OPTIONS.map((id) => (
          <FilterCheckboxItem key={id} id={id} label={getCarrierName(id)} />
        ))}
      </FiltersList>
    </FiltersSubMenu>
  );
};
